export default "__VITE_ASSET__326536d5__"